(function initializeCartRecovery(globalScope) {
  if (!Citiesocial?.cartRecoveryManager) {
    globalScope.__CS_CART_RECOVERY_PROMISE__ = Promise.resolve(false);

    return;
  }

  if (!globalScope.__CS_CART_RECOVERY_PROMISE__) {
    globalScope.__CS_CART_RECOVERY_PROMISE__ = Promise.resolve(
      Citiesocial.cartRecoveryManager.recoverPendingBatchCheckout(),
    ).catch(function () {
      return false;
    });
  }
})(window);
